const legend = isPurchaseReceipt => {
  if(!isPurchaseReceipt) return null

  return I18n.t("mobile.photos.purchase_receipt_default_legend")
}

// Dispatch
export const addPhotoAction = (
  workorder,
  base64,
  isPurchaseReceipt = false,
  maintenanceTaskId = null,
  quoteId           = null,
  fieldId           = null,
  extraFieldAnswerId = null,
  geotag            = null
) => dispatch =>
  dispatch({
    type:    ADD_PHOTO.ACTION,
    payload: { workorder, base64, isPurchaseReceipt, maintenanceTaskId, quoteId, fieldId, extraFieldAnswerId, geotag }
  })

// Reducer response
export const ADD_PHOTO = {
  ACTION: 'ADD_PHOTO',

  call: ({ state, workorder, base64, isPurchaseReceipt, maintenanceTaskId, quoteId, fieldId, extraFieldAnswerId, geotag }) => {
    const photo = {
      photo:   base64,
      legend:  legend(isPurchaseReceipt),
      version: new Date().getTime(),
      synced:  false,
      syncing: false,
      isPurchaseReceipt,
      maintenanceTaskId,
      quoteId,
      fieldId,
      extraFieldAnswerId,
      ...(geotag ? { geotag } : {})
    }

    return {
      ...state,
      items: state.items.map(item => item.id != workorder.id ? item : {
        ...item,
        synced: false,
        photos: [...item.photos, photo]
      })
    }
  }
}
